import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import VerticalDividerMiddle from './VerticalDividerMiddle';
import ClientProvider from './client';
export default createDemo(import.meta.url, VerticalDividerMiddle, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/dividers/demos/vertical-middle/VerticalDividerMiddle.tsx",
    "fileName": "VerticalDividerMiddle.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Card from '@mui/material/Card';\nimport Divider, { dividerClasses } from '@mui/material/Divider';\nimport FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';\nimport FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';\nimport FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';\nimport FormatBoldIcon from '@mui/icons-material/FormatBold';\n\nexport default function VerticalDividerMiddle() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Card\n      variant=\"outlined\"\n      sx={{\n        display: 'flex',\n        color: 'text.secondary',\n        '& svg': {\n          m: 1,\n        },\n        [`& .${dividerClasses.root}`]: {\n          mx: 0.5,\n        },\n      }}\n    >\n      <FormatAlignLeftIcon />\n      <FormatAlignCenterIcon />\n      <FormatAlignRightIcon />\n      <Divider orientation=\"vertical\" variant=\"middle\" flexItem />\n      <FormatBoldIcon />\n    </Card>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 30,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Card from '@mui/material/Card';\nimport Divider, { dividerClasses } from '@mui/material/Divider';\nimport FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';\nimport FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';\nimport FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';\nimport FormatBoldIcon from '@mui/icons-material/FormatBold';\n\nexport default function VerticalDividerMiddle() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Card\n      variant=\"outlined\"\n      sx={{\n        display: 'flex',\n        color: 'text.secondary',\n        '& svg': {\n          m: 1,\n        },\n        [`& .${dividerClasses.root}`]: {\n          mx: 0.5,\n        },\n      }}\n    >\n      <FormatAlignLeftIcon />\n      <FormatAlignCenterIcon />\n      <FormatAlignRightIcon />\n      <Divider orientation=\"vertical\" variant=\"middle\" flexItem />\n      <FormatBoldIcon />\n    </Card>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 30,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Card",
      "@mui/material/Divider",
      "@mui/icons-material/FormatAlignLeft",
      "@mui/icons-material/FormatAlignCenter",
      "@mui/icons-material/FormatAlignRight",
      "@mui/icons-material/FormatBold"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
